import { defineStore } from 'pinia';
export const useLanguagesStore = defineStore('languages', {
    state: () => ({
        languages: [],
    }),
    actions: {
        setInvoiceLanguages(languages) {
            this.languages = languages;
        },
    },
});
